export default __webpack_public_path__ + "static/media/one-sku.60ad18bb.svg";